export default "__VITE_ASSET__11149e21__"